/* TODO: This should be later reworked into something more generic */
export enum Layout {
    IRC = "irc",
    Group = "group",
    Bubble = "bubble",
}
